import {useCallback, useState} from "react";
import {mergeAll} from "ramda";

export function useValidateForm(schema, formValues, setShowModal) {
    const [errors, setErrors] = useState({});
    const [isValidating, setIsValidating] = useState(false);

    const handleFormSubmit = useCallback(
        (event, successCallback) => {
            event.preventDefault();

            //checks if its validating and only if it's not updates state, for safety (no unnecessary re-renders)
            if (!isValidating) setIsValidating(true);

            schema
                .validate(formValues, { abortEarly: false })
                .then(() => {
                    console.log("successfully validated")
                    setErrors({});
                    successCallback(formValues);
                    setShowModal(false);
                })
                .catch((err) => {
                    if (err.name === "ValidationError") {
                        const errs = mergeAll(
                            err.inner.flatMap((e) => ({ [e.path]: e.errors }))
                        );
                        console.log(errs)
                        setErrors(errs);
                    }
                });

            if (!errors) {
                return true;
            }
        },
        [formValues, isValidating, schema],
    );

    const reValidate = useCallback(
        () => {
            if (!isValidating) return;

            try {
                schema.validateSync(formValues, { abortEarly: false });
                setErrors({});
                return true;
            } catch (err) {
                if (err.name === "ValidationError") {
                    const errs = mergeAll(
                        err.inner.flatMap((e) => ({ [e.path]: e.errors }))
                    );
                    setErrors(errs);
                    return false;
                }
            }
        },
        [formValues, isValidating, schema],
    );

    const resetValidation = useCallback(
        () => {
            setIsValidating(false);
            setErrors({});
        },
        [],
    );

    return {
        errors,
        reValidate,
        handleFormSubmit,
        resetValidation
    };
}
